import { LicenseType } from '@/modules/AddLicense/models/AddLicenseModel'

export const paths = {
  ADD_LICENSE_PAGE: '/cabinet/add-license',
  CREATE_LICENSE_BY_SERIAL_NUMBER: `/cabinet/licenses/create?type=${LicenseType.SerialNumber}`,
  PRODUCTS_SELECT_PAGE: '/cabinet/licenses/products',
}
